import { AbstractBlock } from "./AbstractBlock";

export abstract class VoidBlock extends AbstractBlock{
    voidBlock: boolean = true;

    abstract evalBlock(varEnv: Map<string,any>): IterableIterator<void>;

    /**
     * How many execution steps a void block takes to execute at most. The default value is 1.
     * This method would be overriden by more complex void blocks such as loops and if statements
     * that take more than one step to complete.
     */
    getLength(): number{
        return 1;
    }
}